import Layout from '@/components/layout/LayoutWrapper';
import PatentsLayout from '@/components/patents';

const Patents = () => (
	<Layout pageName="patents" title="Calm - Patents">
		<PatentsLayout />
	</Layout>
);

export default Patents;
